module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile"
  }, [_c('div', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=AdL3iRX3hoI",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "nav-ico",
    attrs: {
      "src": "http://www.iconninja.com/files/210/726/399/player-video-media-play-web-youtube-icon.svg"
    }
  }), _vm._v(" " + _vm._s(_vm.t('System presentation')) + "\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=FDAN3W0Zg-Q",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "nav-ico",
    attrs: {
      "src": "http://www.iconninja.com/files/210/726/399/player-video-media-play-web-youtube-icon.svg"
    }
  }), _vm._v(" " + _vm._s(_vm.t('System description')) + "\n                ")])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "primary-content"
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "ico ico-off",
    attrs: {
      "href": "/logout"
    }
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e13a0c0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/DashboardMobile.vue
// module id = 1353
// module chunks = 2